import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold text-foreground mb-8">Politique de Confidentialité</h1>
        
        <div className="space-y-6 text-muted-foreground leading-relaxed">
          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">1. Introduction</h2>
            <p>
              BrazzaBoost s'engage à protéger la confidentialité de vos données personnelles. Cette politique 
              décrit comment nous collectons, utilisons et protégeons vos informations.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">2. Données Collectées</h2>
            <p className="mb-2">Nous collectons les informations suivantes :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Nom et prénom</li>
              <li>Adresse email</li>
              <li>Numéro de téléphone (facultatif)</li>
              <li>Informations de profil professionnel</li>
              <li>Historique de candidatures</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">3. Utilisation des Données</h2>
            <p className="mb-2">Vos données sont utilisées pour :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Gérer votre compte utilisateur</li>
              <li>Traiter vos candidatures</li>
              <li>Vous envoyer des notifications pertinentes</li>
              <li>Améliorer nos services</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">4. Protection des Données</h2>
            <p>
              Nous utilisons des mesures de sécurité appropriées pour protéger vos données contre tout accès, 
              modification, divulgation ou destruction non autorisés.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">5. Partage des Données</h2>
            <p>
              Vos données ne sont partagées qu'avec les organisations auxquelles vous postulez et uniquement 
              avec votre consentement explicite lors de la soumission d'une candidature.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">6. Vos Droits</h2>
            <p className="mb-2">Vous avez le droit de :</p>
            <ul className="list-disc pl-6 space-y-2">
              <li>Accéder à vos données personnelles</li>
              <li>Rectifier vos données</li>
              <li>Supprimer votre compte</li>
              <li>Vous opposer au traitement de vos données</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">7. Contact</h2>
            <p>
              Pour toute question concernant cette politique, contactez-nous à{' '}
              <a href="mailto:contact@brazzaboost.com" className="text-primary hover:underline">
                contact@brazzaboost.com
              </a>
            </p>
          </section>

          <p className="text-sm mt-8">
            Dernière mise à jour : 5 octobre 2025
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
}
